var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.011 9.41126L9.03337 10.6337C7.51852 9.74363 6.2562 8.48131 5.36617 6.96646L6.58857 5.98886C6.73187 5.87419 6.83314 5.71528 6.87656 5.53697C6.91998 5.35865 6.9031 5.17097 6.82857 5.00326L5.71417 2.49366C5.63425 2.31383 5.49306 2.16822 5.31577 2.0828C5.13849 1.99737 4.93662 1.97769 4.74617 2.02726L2.62457 2.57686C2.42668 2.62875 2.25466 2.75133 2.14101 2.92143C2.02736 3.09154 1.97996 3.29738 2.00777 3.50006C2.38 6.15105 3.6052 8.60879 5.49812 10.5017C7.39104 12.3946 9.84878 13.6198 12.4998 13.9921C12.7024 14.02 12.9082 13.9727 13.0782 13.859C13.2482 13.7453 13.3706 13.5732 13.4222 13.3753L13.9726 11.2545C14.0221 11.064 14.0025 10.8621 13.917 10.6849C13.8316 10.5076 13.686 10.3664 13.5062 10.2865L10.9966 9.17206C10.8289 9.09772 10.6414 9.08086 10.4631 9.12412C10.2849 9.16738 10.1259 9.26833 10.011 9.41126Z",
    stroke: "#DEE1E6",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone2);
export default __webpack_public_path__ + "static/media/phone-2.2a9095099ba5d5e4253ffda14410c282.svg";
export { ForwardRef as ReactComponent };